import React from 'react'
import WhatsAppLogo from '../../assets/Images/whatsapp-logo-1.png'
import '../../styles/components/CTAScreen.scss'
import { isMobile } from 'react-device-detect'
import { useSelector } from 'react-redux'

const CTAScreen = () => {
  const handleCall = () => {
    if (isMobile) {
      const phoneNumber = '+13859991366'.replace('+', '%2B')
      window.location.href = `tel:${phoneNumber}`
    }
  }

  const { selectedId } = useSelector((state) => state.models)

  return (
    <div className='CTA' data-testid='CTA'>
      <div className='CTA__brand'></div>
      <div className='CTA__backdrop'></div>

      <div className='CTA__whatsapp'>
        <button
          type='button'
          className='CTA__whatsapp__btn'
          onClick={handleCall}
        >
          <img
            className='CTA__whatsapp__btn__logo'
            src={WhatsAppLogo}
            alt='WhatsApp Logo'
          />
        </button>
      </div>
      <p className='price'>
        As low as:
        <br /> {`${selectedId === 0 ? '299$' : '$599'}`}/month
      </p>
      <p className='specialist'>TALK TO A SPECIALIST</p>
    </div>
  )
}

export default CTAScreen
